import React, { memo } from 'react';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel.jsx';
import FormPaymentOption from '../components/FormPaymentOption';

const PaymentOptionCreate = (props) => {
  return (
    <div>
      <h1 className="page-header">Payment Option Create</h1>
      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Information</PanelHeader>
            <PanelBody>
              <FormPaymentOption action="create" />
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default memo(PaymentOptionCreate);
